import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { COMPANY } from "@/data/site";

export const CtaButtons = ({ id, light, devisTo = "/devis" }) => (
  <div className="flex flex-wrap gap-3">
    <Link to={devisTo} data-testid={`${id}-devis-btn`} className="inline-flex items-center gap-2 rounded-full bg-[#D82C2C] px-7 py-3.5 text-sm font-bold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b82323]">
      Demander un devis <ArrowRight className="h-4 w-4" />
    </Link>
    <a href={COMPANY.telephoneHref} data-testid={`${id}-call-btn`}
      className={`inline-flex items-center gap-2 rounded-full border px-7 py-3.5 text-sm font-bold transition-colors duration-200 ${light ? "border-white/50 text-white hover:bg-white hover:text-[#0F2840]" : "border-[#0F2840] text-[#0F2840] hover:bg-[#0F2840] hover:text-white"}`}>
      <Phone className="h-4 w-4" /> Appeler le {COMPANY.telephone}
    </a>
  </div>
);

export const Faq = ({ items, id }) => (
  <Accordion type="single" collapsible className="w-full" data-testid={`${id}-faq`}>
    {items.map((f, i) => (
      <AccordionItem key={f.q} value={`q${i}`}>
        <AccordionTrigger className="text-left font-semibold" data-testid={`${id}-faq-q-${i}`}>{f.q}</AccordionTrigger>
        <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.r}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const JsonLd = ({ data }) => {
  const json = JSON.stringify(data);
  useEffect(() => {
    const s = document.createElement("script");
    s.type = "application/ld+json";
    s.text = json;
    document.head.appendChild(s);
    return () => s.remove();
  }, [json]);
  return null;
};

export const Etapes = ({ items }) => (
  <ol className="grid gap-5 md:grid-cols-5" data-testid="etapes">
    {items.map((e, i) => (
      <li key={e.t} className="rounded-lg border border-[#0F2840]/10 bg-white p-6">
        <span className="font-display text-3xl font-semibold text-[#D82C2C]">{i + 1}</span>
        <h3 className="mt-3 font-bold">{e.t}</h3>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">{e.d}</p>
      </li>
    ))}
  </ol>
);
